import { z } from 'zod';
import { optionalE164PhoneSchema, requiredE164PhoneSchema } from './common/phone.js';

export const VendorSchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    name: z.string().min(1, 'form.validation.nameRequired'),
    taxOffice: z.string().optional(),
    taxNumber: z.string().optional(),
    city: z.string().min(1, 'form.validation.cityRequired'),
    address: z.string().min(1, 'form.validation.addressRequired'),
    phone: requiredE164PhoneSchema,
    fax: optionalE164PhoneSchema,
    email: z.string().email('form.validation.invalidEmail').optional().or(z.literal('')),
    kepAddress: z.string().optional(),
    website: z.string().optional(),
    position: z.string().min(1, 'form.validation.positionRequired'),
    companyType: z.string().min(1, 'form.validation.companyTypeRequired'),
    chamberName: z.string().optional(),
    chamberRegistrationNo: z.string().optional(),
    chamberRegistrationDate: z.string().optional(),
    naceCode: z.string().optional(),
    bankIban: z.string().min(1, 'form.validation.bankIbanRequired'),
    bankName: z.string().min(1, 'form.validation.bankNameRequired'),
    bankBranch: z.string().min(1, 'form.validation.bankBranchRequired'),
    contactPerson: z.string().min(1, 'form.validation.contactPersonRequired'),
    contactPhone: optionalE164PhoneSchema,
    contactMobile: optionalE164PhoneSchema,
    contactEmail: z.string().email('form.validation.invalidContactEmail').optional().or(z.literal('')),
    contactUnit: z.string().optional(),
    description: z.string().optional(),
    reviewFrequency: z.enum(['monthly', 'quarterly', 'semi-annual', 'annual', 'biennial']).optional(),
    nextAssessmentReviewDate: z.preprocess((val) => (val === "" ? undefined : val), z.union([z.date(), z.string(), z.number()]).optional()),
    businessOwner: z.string().optional(),
    securityOwner: z.string().optional(),
    type: z.string().min(1, 'form.validation.typeRequired'),
    category: z.string().optional(),
    criticality: z.string().min(1, 'form.validation.criticalityRequired'),
    vendorProductService: z.string().optional(),
    contractExpiration: z.preprocess((val) => (val === "" ? undefined : val), z.union([z.date(), z.string(), z.number()]).optional()),
    vendorBusinessImpact: z.string().optional(),
    slaDetails: z.string().optional(),
    recoveryTimeObjective: z.string().optional(),
    alternateVendor: z.string().optional(),
    status: z.string().default('active'),
    linkedAssets: z.array(z.string()).optional(),
    orderIndex: z.number().default(0),
    customFields: z.record(z.unknown()).optional(),
    createdAt: z.union([z.string(), z.date()]).optional(),
    updatedAt: z.union([z.string(), z.date()]).optional(),
});

export const CreateVendorSchema = VendorSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateVendorSchema = VendorSchema.partial();
export const VendorFormSchema = CreateVendorSchema;
export const VendorSearchSchema = z.object({
    searchTerm: z.string().optional(),
    type: z.string().optional(),
    status: z.string().optional(),
    page: z.number().min(1).optional(),
    pageSize: z.number().min(1).max(100).optional(),
    sortBy: z.string().optional(),
    sortDirection: z.enum(['asc', 'desc']).optional(),
});
